import type { SignatureV2Workflow } from '@/types/signatureV2';

export const hasChinaDealParty = (
  participants: readonly { deal_role_id: number; user: { acc_country?: string } }[]
): boolean => participants.some(
  (participant) => [0, 1].includes(participant.deal_role_id) && participant.user.acc_country === 'China'
);

export const isMultipleSignDocument = (value: unknown): boolean =>
  value === true || value === 1 || value === '1';

type SignatureV2DisplayOptions = {
  enabled?: boolean;
  force?: boolean;
};

export const isSignatureV2TestUiEnabled = (search: string): boolean => new URLSearchParams(search).get('show') === '1';

export const shouldUseSignatureV2Document = (
  value: unknown,
  { enabled = true, force = false }: SignatureV2DisplayOptions = {}
): boolean => enabled && (force || isMultipleSignDocument(value));

export const findDocumentSignatureV2Workflow = (
  workflows: readonly SignatureV2Workflow[],
  documentId: string | number
): SignatureV2Workflow | undefined =>
  workflows.find((workflow) =>
    String(workflow.source_document.id) === String(documentId)
    && !['completed', 'cancelled', 'failed'].includes(workflow.status)
  );
